<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link
                class="btn btn-sm"
                :to="{ name: 'ConnectedUserList' }"
              >
                <i class="fas fa-chevron-left"></i>
              </router-link>
              Connected Users
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Connected Users</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="ConnectedUser">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div class="form-group required">
                    <label class="control-label">Integer Example</label>
                    <input
                      type="text"
                      id="integer_example"
                      name="integer_example"
                      v-bind:class="{
                        'has-error': errors.has('integer_example')
                      }"
                      v-validate="'required'"
                      v-model="value.integer_example"
                      class="form-control integer_example"
                      placeholder="Integer Example"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('integer_example')"
                    >
                      {{ errors.first('integer_example') }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">String Example</label>
                    <input
                      type="text"
                      id="string_example"
                      name="string_example"
                      v-model="value.string_example"
                      class="form-control string_example"
                      placeholder="String Example"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'ConnectedUserForm',
  metaInfo: {
    title: 'Connected Users | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {}
  }),
  methods: {
    handleSubmission () {
      const _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.is_loading = true
          let api_url = '/connected_users'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/connected_users/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({ name: 'ConnectedUserList' })
            })
            .catch(errors => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message)
              }
              _this.$setErrorsFromResponse(errors.response.data)
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/connected_users/' + id
        axios
          .get(api_url)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // console.log("error " + error);
            reject(error)
          })
      })
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then(response => {
            this.value = response.data
          })
          .catch(error => {
            console.log(error.response)
          })
      }

      this.is_loading = false
    }
  },
  mounted () {
    this.initialize()
  }
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
}
</script>
